import { InputField, InputSelectFieldOptions } from 'components/molecules'
import { SELLER_TYPE_OPTIONS } from 'domains/seller/constants'

const ProductSellerTypeFilterField = () => (
  <>
    <InputField
      formGroupClassName={ 'mr-3' }
      type={ 'select' }
      name={ 'seller_type' }
      label={ 'SELLER TYPE' }
      bsSize={ 'sm' }
    >
      <InputSelectFieldOptions
        options={ SELLER_TYPE_OPTIONS }
      />
    </InputField>
  </>
)

export default ProductSellerTypeFilterField
